import ApiUrl from "../../../configTools/api";
const User = JSON.parse(localStorage.getItem("user-info"));

const Get = (doctor,month,setValues) => {
    fetch(ApiUrl.LabAdminPrint_Jobcard_BillingDetailed+"?doctor="+doctor+"&month="+month,{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        console.log(data);
        setValues(data.response);
    });
}

export default {Get};